// @flow

import { Component } from 'react';
import { isEmpty } from 'lodash';

import { TrackingContext } from '@zapier/toolbox-tracking';

import type { publicAppSearchQuery_getAppsByNameContains_edges } from 'web-ssr/graphql/types';

type Props = {
  apps: Array<publicAppSearchQuery_getAppsByNameContains_edges>,
  query: string,
  skipQuery: boolean,
  isLoading: boolean,
};

const hasNewSearchResult = (props: Props, prevProps: Props) => {
  return props.apps !== prevProps.apps && !props.skipQuery && !props.isLoading;
};

// This component is used for tracking service search results. When service
// search query is performed, and the query itself is not empty, this will
// receive the results list from the Container and check to see if it is
// empty or contains results. This information is then sent to our tracking
// endpoint. This allows us to gather information on what people are searching
// for and what people wish we supported.
//
// TODO(neilff): This should probably be performed at the server level now
// that we have a search endpoint. Previously this made sense when all the
// information was searched and sorted on the client-side only.
class TrackServiceSearchResults extends Component<Props> {
  static contextType = TrackingContext;

  componentDidUpdate(prevProps: Props) {
    const { apps } = this.props;

    if (!hasNewSearchResult(this.props, prevProps)) {
      return;
    }

    if (!isEmpty(apps)) {
      this.onTrackFoundApp();
    } else {
      this.onTrackMissingApp();
    }
  }

  onTrackFoundApp = () => {
    const { trackEvent } = this.context;

    return trackEvent('Zapbook: Results in search', {
      searchTerm: this.props.query,
    });
  };

  onTrackMissingApp = () => {
    const { trackEvent } = this.context;

    return trackEvent('Zapbook: No results in search', {
      searchTerm: this.props.query,
    });
  };

  render() {
    return null;
  }
}

export default TrackServiceSearchResults;
